import React, { useEffect, useState } from 'react'
import DayClock from './DayClock'
import { useOperatorContext } from '../login/OperatorContextProvider';
import FooterInfo from './FooterInfo';
import { useWebSocketContext, WebSocketFlag } from '../../providers/WebSocketContextProvider';
import useKiponosNavigator from '../../hooks/useKiponosNavigator';
import useLogout from '../../hooks/useLogout';
import EjectCountdown from './EjectCountdown';
import { useConfigsDataContext } from '../../providers/ConfigsDataContextProvider';
import './Footer.css'

const Footer = () => {  
  const {version, versionCodeName, versionDate} = require('../../../package.json');
  const {operatorState, isOperatorReady, landed, setLanded} = useOperatorContext();
  const {configReloadMsg, loadCycle}                        = useConfigsDataContext();
  const {webSocketState}                                    = useWebSocketContext();  
  const {navToDefaultPage}                                  = useKiponosNavigator();
  const {logout}                                            = useLogout();
  const [showEjectCountdown, setShowEjectCountdown]         = useState(false);

  if (webSocketState.flag === WebSocketFlag.Error) {
    // setConfigReloadMsg({msg:'WebSocket Error Detected, Relogin required', params: '5'});    
    logout();
  }

  useEffect(()=>{
    if (isOperatorReady() && !landed) {
      navToDefaultPage();
      setLanded(true);
    }
  }, [operatorState, isOperatorReady, navToDefaultPage, landed, setLanded]);

  useEffect(()=>{
    if (configReloadMsg && configReloadMsg.msg) {
      setShowEjectCountdown(true);
    }
  }, [configReloadMsg]);
  
  return (
    <div className='footer'>
      <div className='footerLeft'>
        <DayClock />
        <div className='footerSupportTitle'>
          Support:
        </div>
        <div className='footerSupportEmail'>
           HelpDesk@Kiponos.io
        </div> 
        <div className='footerSupportPhone'>
          <span role="img" aria-label="WhatsApp">💬</span>
          +972-54-460-2111
        </div>
      </div>
      
      <div className='footerCenter'>
        <div className='footerCopyrights'>
          Kiponos.io &copy; 2022-2026 All rights reserved | Version: {version} <b style={{color:'white'}} title={versionDate}>{versionCodeName}</b> 
        </div>
      </div>

      <div className='footerRight'>
        <FooterInfo title='' value={operatorState.flag} />
        <FooterInfo title='' value={webSocketState.flag} />
        <FooterInfo title='' value={loadCycle} />

        { showEjectCountdown && <div className='footerMsg'>
                                  <div>{configReloadMsg.msg}</div> <EjectCountdown seconds={configReloadMsg.params} onTimesUp={logout}/>
                              </div>}
      </div>      
    </div>
  )
}


export default React.memo(Footer);